import { React } from "react";
import { Modal, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { passwordReset } from "../../../store/slices/users/usersThunks";
import { closeModal } from "../../../store/slices/modal/modalSlice";
const ResetPasswordUser = () => {
  const dispatch = useDispatch();
  const { userModalData } = useSelector((state) => state.users);

  const resetPassword = () => {
    dispatch(passwordReset(userModalData.email))
    dispatch(closeModal())
    }



  return (
    <>
      <Modal.Header closeButton>
        <Modal.Title>Reset Password</Modal.Title>
      </Modal.Header>
      <Modal.Body>
             Are you sure you want to reset {userModalData.name} {userModalData.lastname}'s password?
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={() => {
            dispatch(closeModal())
          }}
        >
          Close
        </Button>
        <Link >
          <Button variant="primary"  onClick={()=>resetPassword()}>
           Reset Password
          </Button>
        </Link>
      </Modal.Footer>
    </>
  );
};

export default ResetPasswordUser;
